import i18n from "@/libs/i18n";
export default [
  {
    get header() {
      return i18n.t("employee.employees");
    },
    role: "Employees",
    permission: "get-employees",
  },
  {
    get title() {
      return i18n.t("employee.employee-dashboard");
    },
    route: "employee",
    icon: "BriefcaseIcon",
    permission: "get-employees",
    role: "Employees",
  },
  // {
  //   title: 'Employees Salary ',
  //   route: 'employees-salary',
  //   icon: 'DollarSignIcon',
  //   permission: 'get-employeeSalary',
  //   role: 'Employee',
  // },
  {
    get title() {
      return i18n.t("employee.salary-actions");
    },
    route: "salary-actions",
    icon: "MinusCircleIcon",
    permission: "get-salaryAction",
    role: "Employees",
  },
  {
    get title() {
      return i18n.t("employee.job-title");
    },
    route: "employee-job-title",
    icon: "ShieldIcon",
    permission: "get-job",
    role: "Employees",
  },
];
